import { render } from "./NetworkServersList.vue?vue&type=template&id=00b1d70c&ts=true"
import script from "./NetworkServersList.vue?vue&type=script&lang=ts"
export * from "./NetworkServersList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__